import { ReactNode } from 'react';
import { Link, Typography } from '@rossum/ui/material';
import { To, useComponentsContext } from '../ComponentsContext';

export const Breadcrumb = ({
  to,
  children,
}: {
  to?: To;
  children: ReactNode;
}) => {
  const { LinkComponent } = useComponentsContext();
  return to ? (
    <Link
      component={LinkComponent}
      to={to}
      sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'none' } }}
    >
      <Typography variant="caption" color="text.primary">
        {children}
      </Typography>
    </Link>
  ) : (
    <Typography variant="caption" color="text.secondary">
      {children}
    </Typography>
  );
};
